
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Select } from "../../../Components/Select.js";
import { Msg } from "./Types.js";
import { unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__getValidation } from "../../../Shared/Shared.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { Button } from "../../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

function CurrencyConfiguration(props) {
    let elems_3, elems_2;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const currencyOptions = ofArray([{
        label: "€ (EUR)",
        value: "eUR",
    }, {
        label: "CHF",
        value: "cHF",
    }]);
    const selectedCurrency = (props.Currency === "cHF") ? {
        label: "CHF",
        value: "cHF",
    } : {
        label: "€ (EUR)",
        value: "eUR",
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_2 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = [createElement(Select, {
            ComponentState: componentState,
            IsClearable: false,
            Label: t("settings.units.currency"),
            NoOptionsMessage: "general.no_options",
            OnChange: (option) => {
                if (option == null) {
                }
                else {
                    props.Dispatch(new Msg(0, [option.value]));
                }
            },
            Options: currencyOptions,
            PlaceholderKey: "general.select",
            TestId: "currency-select",
            Value: unwrap(selectedCurrency),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = FormState__getValidation(props.FormState, t, "global"), (matchValue_1 == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                Label: matchValue_1,
            }))), delay(() => {
                let elems_1;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_1 = [createElement(Button, {
                    ComponentState: componentState,
                    Label: t("general.save"),
                    OnClick: () => {
                        props.Dispatch(new Msg(2, []));
                    },
                    TestId: "update-currency-configuration",
                    Variant: "primary",
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function UnitsSettings() {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Currency;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems = [createElement(CurrencyConfiguration, {
            Currency: matchValue.fields[0],
            Dispatch: patternInput[1],
            FormState: state_1.FormState,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

